webpackJsonp([4016850265702045000],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"presets\":[\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-es2015/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-stage-1/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-react/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-env/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin: 180px 0;\n  text-align: center;\n\n  & div {\n    line-height: 1;\n  }\n\n  & svg {\n    width: 40px;\n    height: 55px;\n  }\n\n  & h1 {\n    margin: 10px 0 0;\n    font-size: 1rem;\n  }\n\n  & p {\n    margin: 10px 0 0;\n    font-size: 0.68rem;\n  }\n\n  @media (', ') {\n    & svg {\n      width: 50px;\n      height: 67.5px;\n    }\n\n    & h1 {\n      font-size: 1.75rem;\n    }\n\n    & p {\n      font-size: 0.875rem;\n    }\n  }\n'], ['\n  margin: 180px 0;\n  text-align: center;\n\n  & div {\n    line-height: 1;\n  }\n\n  & svg {\n    width: 40px;\n    height: 55px;\n  }\n\n  & h1 {\n    margin: 10px 0 0;\n    font-size: 1rem;\n  }\n\n  & p {\n    margin: 10px 0 0;\n    font-size: 0.68rem;\n  }\n\n  @media (', ') {\n    & svg {\n      width: 50px;\n      height: 67.5px;\n    }\n\n    & h1 {\n      font-size: 1.75rem;\n    }\n\n    & p {\n      font-size: 0.875rem;\n    }\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin: 180px 0;\n\n  & h2 {\n    font-size: 1.75rem;\n  }\n\n  @media (', ') {\n    & h2 {\n      font-size: 2.25rem;\n      text-align: center;\n    }\n  }\n'], ['\n  margin: 180px 0;\n\n  & h2 {\n    font-size: 1.75rem;\n  }\n\n  @media (', ') {\n    & h2 {\n      font-size: 2.25rem;\n      text-align: center;\n    }\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  padding: 0 0 67.56% !important;\n\n  > span {\n    display: block;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-repeat: none;\n    background-position: center;\n    background-size: cover;\n    transform: scale(1);\n    transition: all 200ms ease-out;\n  }\n'], ['\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  padding: 0 0 67.56% !important;\n\n  > span {\n    display: block;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-repeat: none;\n    background-position: center;\n    background-size: cover;\n    transform: scale(1);\n    transition: all 200ms ease-out;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  display: block;\n  overflow: hidden;\n  margin-top: 30px;\n  background: #fff;\n  border-radius: 3px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.16);\n  transition: all 120ms ease-out;\n  color: inherit;\n  text-decoration: none;\n\n  &:hover {\n    color: #20c59d;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.11);\n  }\n\n  & div {\n    padding: 1.5em 1em;\n  }\n\n  & h3 {\n    margin: 0;\n    font-size: 1rem;\n  }\n\n  & p {\n    margin: 0;\n    overflow: hidden;\n    font-size: 0.75em;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    color: #a0a0a0 !important;\n  }\n\n  &:hover ', ' > span {\n    transform: scale(1.05);\n  }\n'], ['\n  display: block;\n  overflow: hidden;\n  margin-top: 30px;\n  background: #fff;\n  border-radius: 3px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.16);\n  transition: all 120ms ease-out;\n  color: inherit;\n  text-decoration: none;\n\n  &:hover {\n    color: #20c59d;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.11);\n  }\n\n  & div {\n    padding: 1.5em 1em;\n  }\n\n  & h3 {\n    margin: 0;\n    font-size: 1rem;\n  }\n\n  & p {\n    margin: 0;\n    overflow: hidden;\n    font-size: 0.75em;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    color: #a0a0a0 !important;\n  }\n\n  &:hover ', ' > span {\n    transform: scale(1.05);\n  }\n']);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactLimeGrid = __webpack_require__("./node_modules/react-lime-grid/lib/index.js");
	
	var _components = __webpack_require__("./src/components/index.js");
	
	var _constants = __webpack_require__("./src/constants.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Hero = _styledComponents2.default.div(_templateObject, _constants.viewport.md);
	
	var Section = _styledComponents2.default.section(_templateObject2, _constants.viewport.md);
	
	var ComponentThumbnail = _styledComponents2.default.div(_templateObject3);
	
	var ComponentLink = _styledComponents2.default.a(_templateObject4, ComponentThumbnail);
	
	var ComponentItem = function ComponentItem(_ref) {
	  var href = _ref.href,
	      title = _ref.title,
	      image = _ref.image;
	  return _react2.default.createElement(
	    _reactLimeGrid.Col,
	    { xs: 12, sm: 6, lg: 4 },
	    _react2.default.createElement(
	      ComponentLink,
	      {
	        href: href,
	        title: title
	      },
	      _react2.default.createElement(
	        ComponentThumbnail,
	        null,
	        _react2.default.createElement('span', {
	          style: { backgroundImage: 'url("components/' + image + '")' }
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          title
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          href
	        )
	      )
	    )
	  );
	};
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_components.Helmet, { title: 'Powerfully React forms state manager' }),
	    _react2.default.createElement(_components.Header, null),
	    _react2.default.createElement(
	      Hero,
	      null,
	      _react2.default.createElement(
	        _reactLimeGrid.Container,
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_components.Logo, null)
	        ),
	        _react2.default.createElement(
	          'h1',
	          null,
	          'react drip form'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Powerfully React forms state manager'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      Section,
	      null,
	      _react2.default.createElement(_components.Demo, null)
	    ),
	    _react2.default.createElement(
	      Section,
	      null,
	      _react2.default.createElement(
	        _reactLimeGrid.Container,
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Features'
	        ),
	        _react2.default.createElement(
	          _reactLimeGrid.Row,
	          { center: 'xs' },
	          _react2.default.createElement(
	            _reactLimeGrid.Col,
	            { xs: 12, md: 8 },
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'HOC based API. (No magic, transparent and open API)'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Free component design. Integration with many UI frameworks.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Rule based validation, and Provide many built-in rules.Support async and sync validation.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Support normalization.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Support Nest fields and Array fields.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Customizable error message. (Support i18n)'
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      Section,
	      null,
	      _react2.default.createElement(
	        _reactLimeGrid.Container,
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Installation'
	        ),
	        _react2.default.createElement(
	          _reactLimeGrid.Row,
	          { center: 'xs' },
	          _react2.default.createElement(
	            _reactLimeGrid.Col,
	            { xs: 12, md: 8 },
	            _react2.default.createElement(
	              _components.Code,
	              { language: 'bash' },
	              '$ npm install react-drip-form --save'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      Section,
	      null,
	      _react2.default.createElement(
	        _reactLimeGrid.Container,
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Components'
	        ),
	        _react2.default.createElement(
	          _reactLimeGrid.Row,
	          { center: 'xs', style: { marginTop: -30 } },
	          _react2.default.createElement(ComponentItem, {
	            href: 'https://github.com/tsuyoshiwada/react-drip-form-components',
	            title: 'Official UI Components',
	            image: 'react-drip-form-components.png'
	          }),
	          _react2.default.createElement(ComponentItem, {
	            href: 'https://github.com/tsuyoshiwada/react-drip-form-material-ui',
	            title: 'Material-UI',
	            image: 'react-drip-form-material-ui.png'
	          }),
	          _react2.default.createElement(ComponentItem, {
	            href: 'https://github.com/tsuyoshiwada/react-drip-form-bootstrap',
	            title: 'React Bootstrap',
	            image: 'react-drip-form-bootstrap.png'
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(_components.Footer, null)
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// page-component---src-pages-index-js-49648c11d4a2b4fe6ca9.js